import { Component, HostListener, computed, inject, signal } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { RestaurantConfigService } from '../../services/restaurant-config.service';
import { resolveRestaurantLogoUrl } from '../../config/default-assets';
import { SectionScrollService } from '../../services/section-scroll.service';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  imports: [
    NgOptimizedImage
  ]
})
export class NavbarComponent {
  private readonly themeService = inject(ThemeService);
  private readonly restaurantConfig = inject(RestaurantConfigService);
  private readonly sectionScroll = inject(SectionScrollService);

  /** Set true together with ThemeService dual-theme mode to show the navbar toggle again. */
  readonly themeToggleVisible = false;

  readonly theme = this.themeService.theme;

  scrolled = signal(false);
  mobileMenuOpen = signal(false);

  readonly profile = this.restaurantConfig.profile;

  readonly logoSrc = computed(() => resolveRestaurantLogoUrl(this.profile()));

  readonly restaurantName = computed(() => this.profile()?.name ?? 'Kanyar Büfé');

  readonly navItems = computed(() => {
    const items: { label: string; anchor: string }[] = [
      { label: 'Rólunk', anchor: 'about' },
      { label: 'Étlap', anchor: 'menu' },
      { label: 'Galéria', anchor: 'gallery' },
    ];
    if (this.restaurantConfig.config().features.reservation) {
      items.push({ label: 'Asztalfoglalás', anchor: 'reservation' });
    }
    items.push({ label: 'Kapcsolat', anchor: 'contact' });
    return items;
  });

  readonly showReservation = computed(
    () => this.restaurantConfig.config().features.reservation
  );

  @HostListener('window:scroll')
  onScroll() {
    this.scrolled.set(window.scrollY > 50);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.update((v) => !v);
  }

  closeMobileMenu() {
    this.mobileMenuOpen.set(false);
  }

  scrollTo(anchor: string) {
    this.closeMobileMenu();
    this.sectionScroll.navigateToLandingSection(anchor);
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
